import { render, staticRenderFns } from "./CreateWrapping.vue?vue&type=template&id=64872e46"
import script from "./CreateWrapping.vue?vue&type=script&lang=js"
export * from "./CreateWrapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports